export interface Purchase {
  target_supplier_id: number;
  organization_id?: number;
  origin_client_id: number;
  value: string;
  quotation_organization: string;
  quotation_real: string;
  asset_id_origin: number;
  asset_id_target: number;
  status?: string;
  createdAt: Date | null;
}


export const INITIAL_FORM: Purchase = {
    target_supplier_id: 0,
    origin_client_id: 0,
    asset_id_origin: 0,
    asset_id_target: 0,
    quotation_real: "",
    quotation_organization: "",
    value: "",
    createdAt: null,
};

export interface IAsset {
    id:     number;
    name:   string;
    symbol: string;
    type:   string;
}

export interface IOrganization {
    id:   number;
    name: string;
}

export interface IUser {
    id:       number;
    name:     string;
    email:    string;
}

export interface IPurchase {
    // Base columns
    id:                     string;
    target_supplier_id:     number;
    organization_id:        number;
    origin_client_id:       number;
    trx_id:                 string;
    value:                  string;
    quotation_organization: string;
    quotation_real:         string;
    // Saldo em BRL com sinal (negativo = prejuizo), vindo do backend.
    saldo?:                 string | null;
    asset_id_origin:        number;
    asset_id_target:        number;
    status:                 PurchaseStatus;
    createdAt:              string;   // ISO string from JSON
    updatedAt:              string;

    // Relations
    assetOrigin:  IAsset;
    assetTarget:  IAsset;
    organization: IOrganization;
    target_user:  IUser;
    origin_user:  IUser;
}

export type PurchaseStatus = 'CREATED' | 'PENDING' | 'COMPLETED' | 'CANCELED' | 'FAILED';

// Status exibidos nas compras (swaps). Apenas estes 4 aparecem na listagem,
// mapeados para valores que o backend ja aceita (TransactionStatus):
// STARTED = CREATED, IN PROGRESS = PENDING.
export const PURCHASE_STATUS_OPTIONS: Array<{ value: PurchaseStatus; label: string }> = [
    { value: 'CREATED',   label: 'STARTED' },
    { value: 'PENDING',   label: 'IN PROGRESS' },
    { value: 'COMPLETED', label: 'COMPLETED' },
    { value: 'CANCELED',  label: 'CANCELLED' },
];

// Status que o owner pode atribuir (o backend so aceita estes dois).
// CANCELED estorna todos os movimentos da compra e e definitivo.
export const PURCHASE_EDITABLE_STATUS_OPTIONS = PURCHASE_STATUS_OPTIONS.filter(
    (o) => o.value === 'COMPLETED' || o.value === 'CANCELED',
);

// Label amigavel do status da compra; status legados fora da lista aparecem
// como vieram da API.
export const purchaseStatusLabel = (status?: string): string => {
    const key = (status ?? '').toUpperCase();
    return PURCHASE_STATUS_OPTIONS.find((o) => o.value === key)?.label ?? (status ?? '');
};